export default __webpack_public_path__ + "static/media/bootstrap-grid.rtl.css.f73b0475.map";